<template>
  <tr class="pricing-table__row">
    <td class="pricing-table__cell pricing-table__cell--xsm">{{ index + 1 }}</td>
    <td class="pricing-table__cell pricing-table__cell--smed">
      <select
        v-model="localTimeUnit"
        @change="setTimeUnit"
      >
        <option 
          v-for="(label, unit) in timeUnits"
          :selected="localTimeUnit === unit"
          :value="unit"
        >{{ label }}</option>
      </select>
    </td>
    <td class="pricing-table__cell pricing-table__cell--lg">
      Alert me 
      <input 
        v-model="localLeadTime"
        type="number" 
        min="1"
        :max="maxLeadTimeValue"
        class="inline" 
        style="width: 60px;"
        @keyup="setLeadTime"
      > 
      {{ this.localTimeUnit }} prior to the {{ moment(this.startMonth).format('MMM YYYY') }} start month
    </td>
    <td class="pricing-table__cell pricing-table__cell--sm" valign="middle" style="vertical-align: middle;">
      <span v-if="alertDate">{{ moment(alertDate).format('M/D/YYYY') }}</span>
    </td>
    <td class="pricing-table__cell pricing-table__cell--xsm">
      <button class="btn btn-tertiary"
        @click="removeTimeBasedAlert(index)"
      ><i class="fa fa-times-circle"></i></button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'

export default {
  props: ['index', 'id', 'modalVisible', 'ordinal', 'pricingRequest', 'pricingRequestId', 'timeUnit', 'leadTime'],
  data () {
    return {
      localTimeUnit: 'days',
      localLeadTime: null,
    }
  },
  computed: {
    timeUnits() {
      return {
        days: 'Days',
        weeks: 'Weeks',
        months: 'Months',
      }
    },
    startMonth() {
      return this.pricingRequest.inputs.startMonth
    },
    alertDate() {
      if (this.localLeadTime && this.localTimeUnit) {
        return moment(this.startMonth).subtract(this.localLeadTime, this.localTimeUnit)
      }
      return null
    },
    maxLeadTimeValue() {
      const now = moment().local()

      // @note When we eventually replace moment.js we'll
      // want to test this before and after 7pm EST (or 8pm EDT)
      // (when the date in UTC changes) to make sure that the 
      // comparison/diff below is using local time.

      // We need to compare the local date to the 
      // local representation of the `startMonth`.
      // 1. Create a local moment.
      let localMoment = moment().local()

      // 2. Create a moment for the `startMonth`.
      let startDateMoment = moment(new Date(this.startMonth))

      // 3. Set the local moment to the `startMonth` by converting 
      // the `startDateMoment` to an object (so we don't have to set
      // the the local moment by individual date parts (e.g. year, month, and day)).
      localMoment.set(startDateMoment.toObject())

      switch (this.localTimeUnit) {
        case 'days':
          return localMoment.diff(now, 'days')

        case 'weeks':
          return Math.floor((localMoment.diff(now, 'days') / 7))

        case 'months':
          return localMoment.diff(now, 'months')
      }
    }
  },
  methods: {
    moment(date) {
      return moment(date)
    },
    removeTimeBasedAlert(index) {
      this.$emit('removeTimeBasedAlert', index)
    },
    setTimeUnit() {
      this.$emit('setTimeUnit', this.index, this.localTimeUnit)
    },
    setLeadTime() {

      // Don't allow an entry greater than the max.
      if (this.localLeadTime > this.maxLeadTimeValue) {
        this.localLeadTime = this.maxLeadTimeValue

        this.$store.dispatch('setNotification', { 
          type: 'error', 
          msg: 'Lead time cannot be greater than ' + this.maxLeadTimeValue + ' ' + this.timeUnit + '.'
        })
      }

      this.$emit('setLeadTime', this.index, this.localLeadTime)
    },
    populateLocalProperties() {
      if (this.timeUnit) {
        this.localTimeUnit = this.timeUnit
      }

      if (this.leadTime) {
        this.localLeadTime = this.leadTime
      }
    }
  },
  created() {
    this.populateLocalProperties()
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.populateLocalProperties()
      }
    },
    timeUnit() {
      this.populateLocalProperties()
    },
    leadTime() {
      this.populateLocalProperties()
    }
  }
}
</script>
